// src/services/nominaService.js
import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const NOM = `${API_BASE}/api/nom`;

function empresaId() {
  return parseInt(localStorage.getItem("empresaId") || "0", 10);
}

// ===== DEPARTAMENTOS =====
export async function obtenerDepartamentos(soloActivos = false) {
  const { data } = await axios.get(`${NOM}/departamentos`, { params: { empresa: empresaId(), soloActivos } });
  return data;
}
export async function crearDepartamento(dto) {
  const { data } = await axios.post(`${NOM}/departamentos`, { ...dto, empresaId: empresaId() });
  return data;
}
export async function actualizarDepartamento(id, dto) {
  await axios.put(`${NOM}/departamentos/${id}`, { ...dto, empresaId: empresaId() });
}
export async function eliminarDepartamento(id) {
  await axios.delete(`${NOM}/departamentos/${id}`);
}

// ===== PUESTOS =====
export async function obtenerPuestos(soloActivos = false) {
  const { data } = await axios.get(`${NOM}/puestos`, { params: { empresa: empresaId(), soloActivos } });
  return data;
}
export async function crearPuesto(dto) {
  const { data } = await axios.post(`${NOM}/puestos`, { ...dto, empresaId: empresaId() });
  return data;
}
export async function actualizarPuesto(id, dto) {
  await axios.put(`${NOM}/puestos/${id}`, { ...dto, empresaId: empresaId() });
}
export async function eliminarPuesto(id) {
  await axios.delete(`${NOM}/puestos/${id}`);
}

// ===== CONCEPTOS =====
export async function obtenerConceptos(tipo = null, soloActivos = false) {
  const params = { empresa: empresaId(), soloActivos };
  if (tipo) params.tipo = tipo;
  const { data } = await axios.get(`${NOM}/conceptos`, { params });
  return data;
}
export async function obtenerConcepto(id) {
  const { data } = await axios.get(`${NOM}/conceptos/${id}`);
  return data;
}
export async function crearConcepto(dto) {
  const { data } = await axios.post(`${NOM}/conceptos`, { ...dto, empresaId: empresaId() });
  return data;
}
export async function actualizarConcepto(id, dto) {
  await axios.put(`${NOM}/conceptos/${id}`, { ...dto, empresaId: empresaId() });
}
export async function eliminarConcepto(id) {
  await axios.delete(`${NOM}/conceptos/${id}`);
}

// ===== EMPLEADOS =====
export async function obtenerEmpleados(page = 1, pageSize = 20, search = "", soloActivos = null) {
  const params = { empresa: empresaId(), page, pageSize };
  if (search) params.search = search;
  if (soloActivos !== null) params.soloActivos = soloActivos;
  const { data } = await axios.get(`${NOM}/empleados`, { params });
  return data;
}
export async function obtenerEmpleado(id) {
  const { data } = await axios.get(`${NOM}/empleados/${id}`);
  return data;
}
export async function crearEmpleado(dto) {
  const { data } = await axios.post(`${NOM}/empleados`, { ...dto, empresaId: empresaId() });
  return data;
}
export async function actualizarEmpleado(id, dto) {
  await axios.put(`${NOM}/empleados/${id}`, { ...dto, empresaId: empresaId() });
}

// ===== CATÁLOGOS FISCALES =====
export async function obtenerSalariosMinimos(anio = null) {
  const params = {};
  if (anio) params.anio = anio;
  const { data } = await axios.get(`${NOM}/catalogos/salarios-minimos`, { params });
  return data;
}
export async function crearSalarioMinimo(dto) {
  const { data } = await axios.post(`${NOM}/catalogos/salarios-minimos`, dto);
  return data;
}
export async function actualizarSalarioMinimo(id, dto) {
  await axios.put(`${NOM}/catalogos/salarios-minimos/${id}`, dto);
}
export async function eliminarSalarioMinimo(id) {
  await axios.delete(`${NOM}/catalogos/salarios-minimos/${id}`);
}

export async function obtenerTablasIsr(anio = null, periodo = null) {
  const params = {};
  if (anio) params.anio = anio;
  if (periodo) params.periodo = periodo;
  const { data } = await axios.get(`${NOM}/catalogos/tablas-isr`, { params });
  return data;
}
export async function crearTablaIsr(dto) {
  const { data } = await axios.post(`${NOM}/catalogos/tablas-isr`, dto);
  return data;
}
export async function eliminarTablaIsr(id) {
  await axios.delete(`${NOM}/catalogos/tablas-isr/${id}`);
}

export async function obtenerRegPatronales() {
  const { data } = await axios.get(`${NOM}/catalogos/reg-patronales`, { params: { empresa: empresaId() } });
  return data;
}
export async function crearRegPatronal(dto) {
  const { data } = await axios.post(`${NOM}/catalogos/reg-patronales`, { ...dto, empresaId: empresaId() });
  return data;
}
export async function actualizarRegPatronal(id, dto) {
  await axios.put(`${NOM}/catalogos/reg-patronales/${id}`, { ...dto, empresaId: empresaId() });
}
export async function eliminarRegPatronal(id) {
  await axios.delete(`${NOM}/catalogos/reg-patronales/${id}`);
}

// ===== PERIODOS =====
export async function obtenerPeriodos(anio) {
  const params = { empresa: empresaId() };
  if (anio) params.anio = anio;
  const { data } = await axios.get(`${NOM}/periodos`, { params });
  return data;
}
export async function crearPeriodo(dto) {
  const { data } = await axios.post(`${NOM}/periodos`, { ...dto, EmpresaId: empresaId() });
  return data;
}
export async function actualizarPeriodo(id, dto) {
  await axios.put(`${NOM}/periodos/${id}`, { ...dto, EmpresaId: empresaId() });
}
export async function eliminarPeriodo(id) {
  await axios.delete(`${NOM}/periodos/${id}`);
}
export async function generarNomina(periodoId) {
  const { data } = await axios.post(`${NOM}/periodos/${periodoId}/generar`);
  return data;
}
export async function calcularNomina(periodoId) {
  const { data } = await axios.post(`${NOM}/periodos/${periodoId}/calcular`);
  return data;
}

// ===== NOMINAS =====
export async function obtenerNominas(periodoId) {
  const { data } = await axios.get(`${NOM}/nominas`, { params: { periodo: periodoId } });
  return data;
}
export async function obtenerNomina(id) {
  const { data } = await axios.get(`${NOM}/nominas/${id}`);
  return data;
}
export async function actualizarNominaDetalle(id, dto) {
  await axios.put(`${NOM}/nominas/${id}`, dto);
}
export async function obtenerRecibo(nominaId) {
  const { data } = await axios.get(`${NOM}/nominas/${nominaId}/recibo`);
  return data;
}
